(function () {
  'use strict';

  function initAgeContextFilter() {
    const productGallery = document.querySelector('product-gallery');
    if (!productGallery) return;

    const stableAncestor = document.querySelector('.product-info__block-list');
    if (!stableAncestor) return;

    let activeContext = null;
    let isBound = false;

    function getAllMediaItems() {
      return Array.from(document.querySelectorAll('.product-gallery__media'));
    }

    function getImageAlt(mediaItem) {
      const img = mediaItem.querySelector('img');
      return (img && img.getAttribute('alt')) || '';
    }

    function altMatchesContext(alt, ctx) {
      if (!alt) return false;
      const tags = alt.toLowerCase().split(',').map(t => t.trim());
      const normalized = tags.map(t => t === 'kids' ? 'youth' : t);
      return normalized.includes(ctx.toLowerCase());
    }

    function applyFilter(ctx) {
      getAllMediaItems().forEach(item => {
        const alt = getImageAlt(item);
        item.style.display = altMatchesContext(alt, ctx) ? '' : 'none';
      });
    }

    function clearFilter() {
      getAllMediaItems().forEach(item => {
        item.style.display = '';
      });
    }

    function syncButtonState() {
      document.querySelectorAll('[data-age-context]').forEach(btn => {
        btn.classList.toggle('is-active', btn.getAttribute('data-age-context') === activeContext);
      });
    }

    function setUrlContext(ctx) {
      const url = new URL(window.location.href);
      if (ctx) {
        url.searchParams.set('age_context', ctx);
      } else {
        url.searchParams.delete('age_context');
      }
      window.history.replaceState({}, '', url.toString());
    }

    function bindButtons() {
      if (isBound) return;
      isBound = true;

      document.querySelectorAll('[data-age-context]').forEach(btn => {
        btn.addEventListener('click', function () {
          const ctx = this.getAttribute('data-age-context');
          if (ctx === activeContext) {
            activeContext = null;
            clearFilter();
            setUrlContext(null);
          } else {
            activeContext = ctx;
            applyFilter(ctx);
            setUrlContext(ctx);
          }
          syncButtonState();
        });
      });
    }

    let debounceTimer = null;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Only re-bind if the age context buttons were replaced
        const btns = document.querySelectorAll('[data-age-context]');
        const anyUnbound = Array.from(btns).some(btn => !btn.dataset.bound);
        if (anyUnbound) {
          btns.forEach(btn => {
            if (btn.dataset.bound) return;
            btn.dataset.bound = 'true';
            btn.addEventListener('click', function () {
              const ctx = this.getAttribute('data-age-context');
              if (ctx === activeContext) {
                activeContext = null;
                clearFilter();
                setUrlContext(null);
              } else {
                activeContext = ctx;
                applyFilter(ctx);
                setUrlContext(ctx);
              }
              syncButtonState();
            });
          });
        }
        syncButtonState();
        if (activeContext) applyFilter(activeContext);
      }, 50);
    });

    observer.observe(stableAncestor, {
      childList: true,
      subtree: true
    });

    const galleryObserver = new MutationObserver(() => {
      if (activeContext) {
        setTimeout(() => applyFilter(activeContext), 50);
      }
    });

    galleryObserver.observe(productGallery, {
      attributes: true,
      attributeFilter: ['filtered-indexes']
    });

    const urlParams = new URLSearchParams(window.location.search);
    const urlCtx = urlParams.get('age_context');
    if (urlCtx) {
      activeContext = urlCtx.toLowerCase();
    }

    setTimeout(() => {
      document.querySelectorAll('[data-age-context]').forEach(btn => {
        if (btn.dataset.bound) return;
        btn.dataset.bound = 'true';
        btn.addEventListener('click', function () {
          const ctx = this.getAttribute('data-age-context');
          if (ctx === activeContext) {
            activeContext = null;
            clearFilter();
            setUrlContext(null);
          } else {
            activeContext = ctx;
            applyFilter(ctx);
            setUrlContext(ctx);
          }
          syncButtonState();
        });
      });
      syncButtonState();
      if (activeContext) applyFilter(activeContext);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeContextFilter);
  } else {
    initAgeContextFilter();
  }
})();
